import { FC } from 'react';

import classes from './pill.module.css';

type PillProps = {
  text: string;
  color?: 'red' | 'yellow' | 'green' | 'blue' | 'gray';
};

export const Pill: FC<PillProps> = ({ text, color = undefined }) => {
  const classString = color ? `${classes.pill} ${classes[color]}` : classes.pill;
  return (<span className={classString}>{text}</span>);
};
